// Starter content. Shipped so the very first launch shows real cards even
// before the parent has ingested a YCIS workbook page.
//
// Traditional characters per YCIS. Mainland-Mandarin pinyin is computed by
// pinyin-pro at seed time, so we don't hand-maintain pinyin strings here.

import type { SemanticTag } from './cardSchema';

export interface StarterCard {
  hanzi: string;
  english: string;
  tag: SemanticTag;
}

export interface StarterLesson {
  id: string;
  title: string;
  zoneTheme: SemanticTag;
  cards: StarterCard[];
  passages: string[];
}

export const STARTER_LESSONS: StarterLesson[] = [
  {
    id: 'starter-animals',
    title: 'Forest of Beasts',
    zoneTheme: 'animals',
    cards: [
      { hanzi: '貓', english: 'cat', tag: 'animals' },
      { hanzi: '狗', english: 'dog', tag: 'animals' },
      { hanzi: '魚', english: 'fish', tag: 'animals' },
      { hanzi: '鳥', english: 'bird', tag: 'animals' },
      { hanzi: '馬', english: 'horse', tag: 'animals' },
      { hanzi: '兔子', english: 'rabbit', tag: 'animals' },
      { hanzi: '老虎', english: 'tiger', tag: 'animals' },
      { hanzi: '熊', english: 'bear', tag: 'animals' },
      { hanzi: '猴子', english: 'monkey', tag: 'animals' },
      { hanzi: '小鳥', english: 'little bird', tag: 'animals' },
    ],
    passages: [
      '小貓喜歡吃魚。',
      '老虎和熊都住在森林裡。',
    ],
  },
  {
    id: 'starter-numbers',
    title: 'Counting Cavern',
    zoneTheme: 'numbers',
    cards: [
      { hanzi: '一', english: 'one', tag: 'numbers' },
      { hanzi: '二', english: 'two', tag: 'numbers' },
      { hanzi: '三', english: 'three', tag: 'numbers' },
      { hanzi: '四', english: 'four', tag: 'numbers' },
      { hanzi: '五', english: 'five', tag: 'numbers' },
      { hanzi: '六', english: 'six', tag: 'numbers' },
      { hanzi: '七', english: 'seven', tag: 'numbers' },
      { hanzi: '八', english: 'eight', tag: 'numbers' },
      { hanzi: '九', english: 'nine', tag: 'numbers' },
      { hanzi: '十', english: 'ten', tag: 'numbers' },
    ],
    passages: [
      '一二三四五。',
      '我有兩個哥哥。',
    ],
  },
  {
    id: 'starter-colors',
    title: 'Rainbow Ridge',
    zoneTheme: 'colors',
    cards: [
      { hanzi: '紅', english: 'red', tag: 'colors' },
      { hanzi: '黃', english: 'yellow', tag: 'colors' },
      { hanzi: '藍', english: 'blue', tag: 'colors' },
      { hanzi: '綠', english: 'green', tag: 'colors' },
      { hanzi: '黑', english: 'black', tag: 'colors' },
      { hanzi: '白', english: 'white', tag: 'colors' },
      { hanzi: '紫', english: 'purple', tag: 'colors' },
      { hanzi: '粉紅', english: 'pink', tag: 'colors' },
    ],
    passages: [
      '紅色的花很漂亮。',
      '天空是藍色的。',
    ],
  },
  {
    id: 'starter-family',
    title: 'Hearth Hall',
    zoneTheme: 'family',
    cards: [
      { hanzi: '媽媽', english: 'mother', tag: 'family' },
      { hanzi: '爸爸', english: 'father', tag: 'family' },
      { hanzi: '哥哥', english: 'older brother', tag: 'family' },
      { hanzi: '姐姐', english: 'older sister', tag: 'family' },
      { hanzi: '弟弟', english: 'younger brother', tag: 'family' },
      { hanzi: '妹妹', english: 'younger sister', tag: 'family' },
      { hanzi: '我', english: 'I / me', tag: 'family' },
      { hanzi: '你', english: 'you', tag: 'family' },
    ],
    passages: [
      '我有一個哥哥和一個妹妹。',
      '媽媽和爸爸都很愛我。',
    ],
  },
];
